import * as actionTypes from '../actions/actionTypes';
import {
  updateObject
} from '../../shared/utility';

const initialState = {
  connectivity: null,
  error: false,
  loading: false,
  loaded:false,
  showSideMenu:null,
  status: null,
  spectrumStatus: {},
  spectrumStatusLoading: false,
  spectrumStatusError: false
};

const initConnectivityStart = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: true,
    loaded:false
  });
};

const setConnectivity = (state, action) => {
  // console.log('SPECRES')
  return updateObject(state, {
    connectivity: action.connectivity==='noService'?false:true,
    status:action.connectivity,
    loading: false,
    loaded: true,
  });
};

const showSideMenu = (state, action) => {
  return updateObject(state, {
    showSideMenu:true
  });
};

const dontShowSideMenu = (state, action) => {
  return updateObject(state, {
    showSideMenu:null
  });
};

const fetchConnectivityFailed = (state, action) => {
  return updateObject(state, {
    loaded: true,
    loading: false,
    error: true
  });
};

const setSpectrumStatus = (state, action) => {
  return updateObject(state, {
    spectrumStatus: action.payload,
    spectrumStatusLoading: false,
    spectrumStatusError: false
  });
};

const fetchSpectrumStatusFailed = (state, action) => {
  return updateObject(state, {
    spectrumStatus: {},
    spectrumStatusLoading: false,
    spectrumStatusError: true
  });
};

const spectrumStatusStart = (state, action) => {
  return updateObject(state, {
    spectrumStatus: {},
    spectrumStatusLoading: true,
    spectrumStatusError: false
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.INIT_CONNECTIVITY_START:
      return initConnectivityStart(state, action);
    case actionTypes.SHOW_SIDE_MENU:
      return showSideMenu(state, action);
    case actionTypes.DONT_SHOW_SIDE_MENU:
      return dontShowSideMenu(state, action);
    case actionTypes.SET_CONNECTIVITY:
      return setConnectivity(state, action);
    case actionTypes.FETCH_CONNECTIVITY_FAILED:
      return fetchConnectivityFailed(state, action);
    case actionTypes.SET_SPECTRUM_STATUS:
      return setSpectrumStatus(state, action);
      case actionTypes.GET_SPECTRUM_STATUS_FAILED:
      return fetchSpectrumStatusFailed(state, action);
      case actionTypes.INIT_SPECTRUM_STATUS_START:
        return spectrumStatusStart(state, action);
    default:
      return state;
  }
};

export default reducer;
